import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { ReactNode } from "react";

interface Props {
  items: { q: string; a: string; answer?: ReactNode }[];
  heading?: string;
  eyebrow?: string;
}

export function Faq({ items, heading = "Vanliga frågor", eyebrow = "FAQ" }: Props) {
  return (
    <section className="container-page py-16 md:py-24">
      <div className="grid md:grid-cols-[1fr_2fr] gap-10">
        <div>
          <div className="eyebrow">{eyebrow}</div>
          <h2 className="mt-3 text-3xl md:text-4xl">{heading}</h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {items.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left text-base md:text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-foreground/80 leading-relaxed">
                {item.answer ?? item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
